var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4896 27.0795C16.8796 22.9195 15.1697 19.1295 8.92969 18.5195C15.1597 17.9095 16.8796 14.1195 17.4896 9.95947C18.0996 14.1195 19.8097 17.9095 26.0497 18.5195C19.6897 19.1295 17.9796 22.9195 17.4896 27.0795Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09888 13.6295C6.60888 10.3295 5.26891 7.39942 0.378906 6.90942C5.26891 6.41942 6.60888 3.48945 7.09888 0.189453C7.58888 3.48945 8.92885 6.41942 13.8188 6.90942C8.80885 7.39942 7.45888 10.3295 7.09888 13.6295Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6393 6.28918C21.5193 5.06918 21.0292 3.96918 19.1992 3.84918C21.0292 3.72918 21.5193 2.62918 21.6393 1.40918C21.7593 2.62918 22.2492 3.72918 24.0792 3.84918C22.2492 3.96918 21.7593 5.06918 21.6393 6.28918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/generate-icon.9ef9d6899f465f9f7b8f685178bbd4fc.svg";
export { ForwardRef as ReactComponent };